import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import InputMask from 'react-input-mask';
import { TextField } from '../';
const PhoneField = forwardRef((props, ref) => {
    return (_jsx(InputMask, Object.assign({ mask: "(999) 999-9999" }, props, { maskChar: null }, { children: () => (_jsx(TextField, Object.assign({ autoComplete: "tel", label: "Phone number", placeholder: "(000) 000-0000", type: "tel", inputRef: ref }, props), void 0)) }), void 0));
});
export default PhoneField;
